import './helpers/ie11isIntegerPolyfill';
import initGDPRBannerV2 from './actions/initGDPRBannerV2';
import addRavenProjectContext from './helpers/addRavenProjectContext';

window.addEventListener('DOMContentLoaded', async () => {
  addRavenProjectContext();

  await initGDPRBannerV2();
});
